export default "__VITE_ASSET__JEvaTeVI__"